import varAxios from "../../../Comman/axios";
import { getAlarmListUrl, getImageListUrl,getUpdatedAlarmStatusListUrl,GetRegionListUrl} from '../../../Comman/apiEndPoints';

export const ALARM_LIST_REQUEST = "(feedback) ALARM_LIST_REQUEST";
export const ALARM_LIST_SUCCESS = "(feedback) ALARM_LIST_SUCCESS";
export const IMAGE_LIST_SUCCESS = "IMAGE_LIST_SUCCESS";
export const UPDATED_ALARM_STATUS_LIST_SUCCESS = "UPDATED_ALARM_STATUS_LIST_SUCCESS";
export const Fetch_All_Region_Data1 = "Fetch_All_Region_Data1";
export function getAlarmListFunc(RegionId,dispatch) {
    return (dispatch) => {
        dispatch(getAlarmListRequest(true));
        return varAxios.post(getAlarmListUrl,RegionId,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
               
                dispatch(
                    alarmListSuccess(false,
                     response.data.Message, 
                     response.data.statusCode, 
                     response.data.errorCode,
                     response.data.alarmDataList,
                     response.data.pageNumber,
                    response.data.pageSize,
                    response.data.totalRecord
                    )
                );
            })
            .catch((error) => {
                
            })
    }
}
/* export function getAlarmListFunc(dispatch) {
    return (dispatch) => {
        dispatch(getAlarmListRequest(true));
        return varAxios.get(getAlarmListUrl)
            .then((response) => {
                dispatch(
                    alarmListSuccess(false,
                     response.data.Message, 
                     response.data.statusCode, 
                     response.data.errorCode,
                     response.data.alarmDataList
                    )
                );
            })
            .catch((error) => {
                
            })
    }
} */
export function getAlarmListRequest(isLoading) {
    return {
        type: ALARM_LIST_REQUEST,
        isLoading
    }
}
export function alarmListSuccess(isLoading, message, statusCode, errorCode, list,pageNumber,pageSize,totalRecord) {
    return {
        type: ALARM_LIST_SUCCESS,
        isLoading,
        message,
        statusCode,
        errorCode,
        list,
        pageNumber,pageSize,totalRecord
    }
}

export function getImageListFunc(data) {
    return (dispatch) => {
        dispatch(getAlarmListRequest(true));
        return varAxios.post(getImageListUrl, data)
            .then((response) => {
                dispatch(
                    imageListSuccess(false,
                     response.data.Message, 
                     response.data.statusCode, 
                     response.data.errorCode,
                     response.data.caseImageList
                    )
                );
            })
            .catch((error) => {
                
            })
    }
}

export function imageListSuccess(isLoading, message, statusCode, errorCode, list) {
    return {
        type: IMAGE_LIST_SUCCESS,
        isLoading,
        message,
        statusCode,
        errorCode,
        list
    }
}

export function getUpdatedAlarmStatusFunc(data) {
    return (dispatch) => {
        dispatch(getAlarmListRequest(true));
        return varAxios.post(getUpdatedAlarmStatusListUrl, data)
            .then((response) => {
                dispatch(
                    updatedAlarmStatusSuccess(false,
                     response.data.Message, 
                     response.data.statusCode, 
                     response.data.errorCode,
                     response.data.updateAlarmStatusList
                    )
                );
            })
            .catch((error) => {
                  dispatch(
                    updatedAlarmStatusSuccess(false,
                     '', 
                     null, 
                     null,
                     []
                    )
                );
            })
    }
}

export function updatedAlarmStatusSuccess(isLoading, message, statusCode, errorCode, list) {
    return {
        type: UPDATED_ALARM_STATUS_LIST_SUCCESS,
        isLoading,
        message,
        statusCode,
        errorCode,
        list
    }
}

  export function getAllRegionSettings() {
  let requestPayload={
    UserId:sessionStorage.getItem('SuperAdminUserID')
  }
    return(dispatch) =>{
       return varAxios.post(GetRegionListUrl,requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
       .then(response => {
       
       
        this.getAlarmListFunc({RegionId:response.data.regionList[0].ID,IsShowAllAlarm:false,  SortField: "CreatedDate",
    SortOrder: 2})
          dispatch(
            fetchAllRegionData({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              regionList : response.data.regionList
             }));
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAllRegionData({errorCode, statusCode, regionList}) {
  return {
    type : Fetch_All_Region_Data1,
    errorCode,
    statusCode,
    regionList
  }
}
